const t = {
  name: "CreditcardStartPaymentFilled",
  dimensions: { width: 24, height: 24 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M0,4v2h2.4C2.2,6.4,2,6.9,2,7.4L1.7,9h22L24,7.4l0,0C24.2,5.6,22.8,4,21,4H0z"/>
		<path class="st0" d="M0.6,16.6L1.4,11h22l-0.8,5.6c-0.3,2-2,3.4-4,3.4H3.6C1.8,20,0.4,18.4,0.6,16.6z M8.8,14h-4v2h4V14z"/>
	</g>
</g>
</svg>
  `
};
export {
  t as CreditcardStartPaymentFilled
};
